import { useEffect, useState } from 'react';
import { ReactComponent as LoaderSecondary } from '../../assets/SpinnerBlack.svg';

export const Redirector = () => {
  const [redirText, setRedirText] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hashParams = parseHashFragment(window.location.hash);

    const redirUrl = params.get('directRedir');
    if (redirUrl) {
      try {
        const url = new URL(redirUrl);
        window.location.href = url.toString();
        return;
      } catch (err) {
        setRedirText(`URL inválida: ${redirUrl}`);
        return;
      }
    }

    const stateRaw = hashParams['state'];
    if (!stateRaw) {
      setRedirText('State ausente.');
      return;
    }

    let state: any;
    try {
      state = JSON.parse(decodeURIComponent(stateRaw));
    } catch {
      setRedirText('State malformado.');
      return;
    }

    const loginBrand = state.loginBrand;
    const webView = state.webView;
    const hashString = new URLSearchParams(hashParams).toString();

    if (loginBrand) {
      const uri = webView
        ? `https://app.spott.eco/${loginBrand}/app${
            hashString ? `#${hashString}` : ''
          }`
        : `${window.location.origin}/${loginBrand}${
            hashString ? `#${hashString}` : ''
          }`;

      window.location.replace(uri);
      return;
    }

    const isCms = state.isCms;
    const cmsUrl = state.cmsUrl;

    if (isCms && cmsUrl) {
      window.location.replace(cmsUrl + `#${hashString}`);
      return;
    }

    setRedirText('loginBrand ausente.');
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {redirText ? <p>{redirText}</p> : <LoaderSecondary className='spinner' />}
    </div>
  );
};

function parseHashFragment(hash: string) {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const out: Record<string, string> = {};
  params.forEach((v, k) => (out[k] = v));
  return out;
}
